export const accentChairs = [

    {
        id: 1,
        name: 'Boutwell Armchair',
        price: '$100',
        imageUrl: 'https://i.ibb.co/s2Cp2nZ/photo-1501045661006-fcebe0257c3f.jpg'
    },
    {
        id: 2,
        name: 'Annie armchair',
        price: '$120',
        imageUrl: 'https://i.ibb.co/CW2gFhT/photo-1506439773649-6e0eb8cfb237.jpg'
    },
    {
        id: 3,
        name: 'Montecito Armchair',
        price: '$100',
        imageUrl: 'https://i.ibb.co/KcnWT7j/photo-1519947486511-46149fa0a254.jpg'
    },
    {
        id: 4,
        name: 'Royal  Barrel Chair',
        price: '$190',
        imageUrl: 'https://i.ibb.co/jrLDY7Y/koig-interiors-3-CCLagdihtj-M.jpg'
    },
    {
        id: 5,
        name: 'Aiden Wingback Chair',
        price: '$200',
        imageUrl: 'https://i.ibb.co/MckcqQq/photo-1572297794744-a19043e308f8.jpg'
    },
    {
        id: 6,
        name: 'Elosie Swivel Armchair',
        price: '$150',
        imageUrl: 'https://i.ibb.co/vJRj1mb/photo-1580480055273-228ff5388ef8.jpg'
    },
    {
        id: 7,
        name: 'Anderson Lounge Chair',
        price: '$200',
        imageUrl: 'https://i.ibb.co/3hcS4Ct/photo-1584553193958-1e13dda62d3c.jpg'
    },
    {
        id: 8,
        name: 'collect Armchair',
        price: '$120',
        imageUrl: 'https://i.ibb.co/GPr9cQF/photo-1586158291800-2665f07bba79.jpg'
    },
    {
        id: 9,
        name: 'Carpio Club Chair',
        price: '$160',
        imageUrl: 'https://i.ibb.co/nbLY6sZ/photo-1589131776434-a28df2fdc27a.jpg'
    },
    {
        id: 10,
        name: 'Lilo Barrel Chair',
        price: '$170',
        imageUrl: 'https://i.ibb.co/ZcHgBnq/photo-1589584649628-b597067e07a3.jpg'
    },
    {
        id: 11,
        name: 'Bradbury Side Chair',
        price: '$160',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/29626865/resize-h310-w310%5Ecompr-r85/9739/97398002/Deane+Upholstered+Dining+Chair.jpg'
    },
    {
        id: 12,
        name: 'Harval Chair',
        price: '$160',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/32605646/resize-h310-w310%5Ecompr-r85/6496/64960226/Vincent+24%2522+Armchair.jpg'
    },
    {
        id: 13,
        name: 'Altah Chair',
        price: '$150',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/98427808/resize-h310-w310%5Ecompr-r85/4051/40518362/Altha+Armchair.jpg'
    },
    {
        id: 14,
        name: 'Zeller Chair',
        price: '$200',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/32579031/resize-h310-w310%5Ecompr-r85/8396/83969438/Zeller+Armchair.jpg'
    },
    {
        id: 15,
        name: 'Dulen Velvet Chair',
        price: '$100',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/51744815/resize-h310-w310%5Ecompr-r85/1203/120350029/Jeremiah+Swivel+Barrel+Chair.jpg'
    },
    {
        id: 16,
        name: 'Lilo Barrel Chair',
        price: '$100',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/99785163/resize-h310-w310%5Ecompr-r85/6507/65077094/Alec+21%2522+Armchair.jpg'
    },
    {
        id: 17,
        name: 'Caren Sviwel Chair',
        price: '$150',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/05456937/resize-h310-w310%5Ecompr-r85/2730/27305966/Emerson+Armchair.jpg'
    }


];